// extracted by mini-css-extract-plugin
module.exports = {"container":"DesktopNav_container__1NSzl","link":"DesktopNav_link__21VAk","dark":"DesktopNav_dark__10rMt"};